<ix-modal-header icon="image">
  {{ 'battery_pass.image_picker.modal_title' | translate }}
</ix-modal-header>

<ix-modal-content>
  <p class="mb-3">{{ 'battery_pass.image_picker.modal_description' | translate }}</p>

  <div class="image-grid">
    @for (image of images; track image; let i = $index) {
      <div
        class="image-tile d-flex justify-content-center background-image"
        [class.image-tile--selected]="selectedImage === image"
        (click)="onImageClick(image)"
        (keypress)="onImageClick(image)"
        tabindex="0"
        role="button"
        [attr.aria-label]="'battery_pass.image_picker.image_aria_label' | translate: { index: i + 1 }"
        [attr.aria-pressed]="selectedImage === image"
      >
        <img
          [src]="image"
          [alt]="'battery_pass.image_picker.image_alt' | translate: { index: i + 1 }"
          class="image-tile__img"
        />
        @if (selectedImage === image) {
          <div class="image-tile__overlay">
            <ix-icon name="success" size="32" class="image-tile__checkmark"></ix-icon>
          </div>
        }
      </div>
    }
  </div>
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    class="dismiss-modal"
    (click)="onCancel()"
    onkeypress=""
    variant="secondary"
  >
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    (click)="onConfirm()"
    [disabled]="!selectedImage"
    onkeypress=""
    variant="primary"
  >
    {{ 'battery_pass.image_picker.apply_button' | translate }}
  </ix-button>
</ix-modal-footer>
